import { Component, OnInit, OnDestroy, ElementRef, ViewChild, Injectable } from '@angular/core';
import { NbThemeService, NbColorHelper } from '@nebular/theme';
import { icons } from 'eva-icons';
import * as moment from 'moment';
import * as _ from 'lodash';
import Chart from 'chart.js';
import {MapService} from '../../services/map.service'
import { MainService } from 'src/app/services/main.service';

type ChartData = [{date, value, count}];
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
@Injectable({
  providedIn: 'root',
 })
export class HomeComponent implements OnInit {
  spinerGrafica = true;
  data: any;

  usuario: any[];
  reservas: any[];

  capas: any[];

  filter: any;

  capasVisualizar: any[] = [];

  constructor(
    public mapservice: MapService,
    public mainService: MainService,
  ) {
    this.mainService.filtroGEP$.subscribe( obj => {
      this.filter  = obj;
    })
  }
  ngOnInit() {
    this.capas = this.mapservice.LayerSelect;
  }

  actualizarCapas(e){
    this.capasVisualizar = this.capas;
  }

}
